import { makeStyles } from '@material-ui/core/styles'
export default makeStyles(() => ({ 
  back: {
    backgroundColor: '#f14668',
    color: '#ffffff'
  },
  next: {
    backgroundColor: '#290149',
    color: '#ffffff'
  },
  
}))
